import { DatePicker } from '@3plearning/react-components';
import UIHelper from '../../helpers/ui-helper';

export const getDateRange = (selectedDate, academicYear) => {
    let dateRange;
    if (selectedDate.startDate === null) {
        dateRange = {
            startDate: academicYear.startDate,
            endDate: academicYear.endDate
        };
    } else {
        dateRange = {
            startDate: selectedDate.startDate,
            endDate: selectedDate.endDate
        };
    }
    dateRange = UIHelper.formatDateRange(dateRange);
    if (selectedDate.type === DatePicker.LIFETIME) {
        dateRange = `+Prior ${dateRange}`;
    }
    return dateRange;
};



// WEBPACK FOOTER //
// ./components/sub-heading/sub-heading-helpers.js